import { format, getDay, isBefore } from 'date-fns';
import { capitalize } from 'lodash';

import {
    Days,
    DaysEnum,
    HoursOfOperation,
    HoursOfOperations,
} from '@barboxx/types';

import { parseHoursOfOperationTime } from './times';

// Generated by Copilot

function formatTime(time: string) {
    return format(parseHoursOfOperationTime(time), 'hh:mm aa');
}

function displayFromHours(hours: HoursOfOperation, currentDay: Days) {
    return `${capitalize(currentDay)}: ${formatTime(hours.open)} - ${formatTime(hours.close)}`;
}

export function hoursOfOperationDisplay(data: HoursOfOperations) {
    const now = Date.now();
    const dayOfWeek = getDay(now);
    const currentDay = DaysEnum[dayOfWeek] as Days;
    const previousDay = DaysEnum[(dayOfWeek - 1 + 7) % 7] as Days;

    const currentHours = data?.[currentDay] as HoursOfOperation | null;
    const previousHours = data?.[previousDay] as HoursOfOperation | null;

    if (previousHours?.close) {
        const closeTime = parseHoursOfOperationTime(previousHours.close);
        const openTime = parseHoursOfOperationTime(previousHours.open);

        if (isBefore(closeTime, openTime)) {
            if (isBefore(now, closeTime)) {
                return displayFromHours(previousHours, previousDay);
            }
        }
    }

    if (!currentHours) {
        return 'Closed';
    }

    const isBeforeOpen = currentHours.open
        ? isBefore(now, parseHoursOfOperationTime(currentHours.open))
        : true;

    if (isBeforeOpen) {
        return `Opening at ${formatTime(currentHours.open)} ${currentDay}`;
    }

    return displayFromHours(currentHours, currentDay);
}
